// extracted by mini-css-extract-plugin
export default {"root":"option-props_root__hqEHk","placeHolderShimmer":"option-props_placeHolderShimmer__-VCmX"};